import { render, staticRenderFns } from "./DonutChart52.vue?vue&type=template&id=9c8cc056&scoped=true"
import script from "./DonutChart52.vue?vue&type=script&lang=js"
export * from "./DonutChart52.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8cc056",
  null
  
)

export default component.exports